const React = require('react');
const PropTypes = require('prop-types');

require('./TooltipValueTitle.scss');

const TooltipValueTitle = props =>
    props.payload && props.payload[0] && props.payload[0].payload ? (
        <div className="tooltip-value-title">
            <p>
                <b>{props.titleFormat(props.titleKey(props))}</b>
            </p>
            {props.payload.map(p => (
                <p key={p.dataKey}>
                    <span
                        className="disk"
                        style={{ backgroundColor: p.stroke }}
                    />
                    &nbsp;
                    {props.valueFormat(props.valueKey(p))}
                    &nbsp;
                    {p.unit}
                </p>
            ))}
        </div>
    ) : (
        ''
    );

TooltipValueTitle.defaultProps = {
    titleFormat: title => title,
    titleKey: props => props.label,
    valueFormat: v => v,
    valueKey: v => v.value,
};

TooltipValueTitle.propTypes = {
    payload: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    titleFormat: PropTypes.func,
    titleKey: PropTypes.func,
    valueFormat: PropTypes.func,
    valueKey: PropTypes.func,
};

module.exports = TooltipValueTitle;
